export default "/images/arrow-long-up.svg?2d03451f99cee93b966127b55b288c82";